export const routes=['/opportunities','/opportunities/:id','/bids','/awards'];